import { render, staticRenderFns } from "./VSalesRevenueTable.vue?vue&type=template&id=18d12643"
import script from "./VSalesRevenueTable.vue?vue&type=script&lang=js"
export * from "./VSalesRevenueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports